import "./CallDetails.css";
const SpamReportTable = ({ data, formatEnteredDate }) => {
  return (
    <div
      className="custom-container spam-records"
      style={{ borderColor: "inherit" }}
    >
      <table
        className="custom-table table-sec"
        style={{ borderCollapse: "collapse" }}
      >
        <thead>
          <tr>
            <th>UCID</th>
            <th>GLID</th>
            <th>Date</th>
            <th>Cust Type</th>
            <th>Block Date</th>
          </tr>
        </thead>
        <tbody>
          {!data || data.length === 0 ? (
            <tr>
              <th colSpan={5} style={{ textAlign: "center" }}>
                No spam records found.
              </th>
            </tr>
          ) : (
            data.map((details, index) => (
              <tr key={index}>
                <th>{(details?.reason).split("~~")[0] ?? ""}</th>
                <th>{details?.fk_glusr_usr_id}</th>
                <th>{formatEnteredDate(details?.entered_date, true)}</th>
                <th>{details.glusr_usr_custtype_name ?? "-"}</th>
                <th>{formatEnteredDate(details?.entered_date)}</th>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SpamReportTable;